import { notification } from 'antd'
import { useMutation, useQueryClient } from 'react-query'
import { useTranslation } from 'react-i18next'

import { QUERY_KEYS } from '@api'
import { useHandleNewTicketModal } from '@contexts'
import { AxiosErrorType } from '@types'

import { TicketsApi } from './api'

const useCreateTicket = () => {
  const { t } = useTranslation()
  const tPreffix = 'suppliers_router.suppliers_dashboard.use_create_ticket.'
  const { setIsNewTicketModalOpen } = useHandleNewTicketModal()

  const queryClient = useQueryClient()
  const onCreateSuccess = () => {
    setIsNewTicketModalOpen(false)
    queryClient.invalidateQueries(QUERY_KEYS.TICKETS)
  }

  const { mutate, isLoading } = useMutation(TicketsApi.createTicket, {
    onSuccess: data => {
      notification.success({
        message: [
          t(`${tPreffix}new_ticket_notification`),
          `${data.tickets.map(ticket => ` ${ticket.id}`)}`,
        ],
      })
      onCreateSuccess()
    },
    onError: (err: unknown) => {
      const error = err as AxiosErrorType

      const errorResponse = error.data.error as {
        type: string
        status: number
        message: string
      }

      if (errorResponse.type === 'NO_ACTIVE_ROUTE') {
        const hint =
          errorResponse.message.length > 62
            ? `${t(`${tPreffix}no_active_route_hint`)} ${errorResponse.message.substring(
                62,
                errorResponse.message.length,
              )}`
            : `${t(`${tPreffix}no_active_route_at_all_hint`)}`

        notification.error({
          message: `${t(`${tPreffix}no_active_route`)} ${hint}`,
        })
      } else {
        notification.error({
          message: t(`${tPreffix}error`),
        })
      }
    },
  })

  return {
    createTicket: mutate,
    isLoading,
  }
}

export { useCreateTicket }
